module.exports = __webpack_public_path__ + "img/ico064.7f15a09c.svg";